// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UB-_","left":"styles_left__Ywl8A"};